import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "@/api/auth.js"
import Pusher from "pusher-js"

const state = {
  chatPusherClient: null,
  coachPusherClient: null,
}

const getters = {
  chatPusherClient: state => state.chatPusherClient,
  coachPusherClient: state => state.coachPusherClient,
}

const mutations = {
  setChatPusherClient: (state, client) => (state.chatPusherClient = client),
  setCoachPusherClient: (state, client) => (state.coachPusherClient = client),
}

const actions = {
  initChatPusher ({ commit, state }) {
    if (state.chatPusherClient) {
      return
    }
    // eslint-disable-next-line no-undef
    const pusherClient = new Pusher(process.env.PUSHER_APP_KEY, {
      cluster: process.env.PUSHER_APP_CLUSTER,
      authorizer: (channel, options) => ({
        authorize: async (socketId, callback) => {
          try {
            const response = await axios({
              method: "post",
              url: process.env.CHAT_API_URL + "broadcasting/auth",
              headers: getAuthHeaders(),
              data: {
                channel_name: channel.name,
                socket_id: socketId,
              },
            })
            const auth = response.data ? response.data : "NO_AUTH"
            // eslint-disable-next-line standard/no-callback-literal
            callback(false, auth)
          } catch (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback(true, null)
          }
        },
      }),
    })
    commit("setChatPusherClient", pusherClient)
  },
  initCoachPusher ({ commit, state }) {
    if (state.coachPusherClient) {
      return
    }
    // eslint-disable-next-line no-undef
    const pusherClient = new Pusher(process.env.PUSHER_APP_KEY, {
      cluster: process.env.PUSHER_APP_CLUSTER,
      authorizer: (channel, options) => ({
        authorize: async (socketId, callback) => {
          try {
            const response = await axios({
              method: "post",
              url: process.env.INSTAPRO_API_URL + "broadcasting/auth",
              headers: getAuthHeaders(),
              data: {
                channel_name: channel.name,
                socket_id: socketId,
              },
            })
            const auth = response.data ? response.data : "NO_AUTH"
            // eslint-disable-next-line standard/no-callback-literal
            callback(false, auth)
          } catch (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback(true, null)
          }
        },
      }),
    })
    commit("setCoachPusherClient", pusherClient)
  },
  async listenInventoryUpdate ({ state, rootGetters, dispatch }) {
    await dispatch("User/loadUser", null, { root: true })
    const user = rootGetters["User/getUser"]
    if (!user) return
    const channelName = `private.proguides.user-${user.id}.general`
    if (!state.coachPusherClient) {
      console.error("Unable to set up listener for 'user.inventory.updated'. Pusher client not instantiated.")
      return
    }
    const channel = state.coachPusherClient.subscribe(channelName)
    // Remove existing bindings to avoid duplicates
    channel.unbind("user.inventory.updated")
    channel.bind("user.inventory.updated", async data => {
      await dispatch("User/Inventory/loadInventory", true, { root: true })
      dispatch("Util/updateCoverLoading", false, { root: true })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/pusher/pusher.module.js